import React from 'react';
import { StatusPills } from 'components/StatusPills/StatusPills';
import { Appearance } from 'design/types';
import { IPayoutStats, PAYOUT_STATUS_DISPLAY_ORDER, PayoutStatus } from 'types';
import { getPayoutNetTotalByStatus, getPayoutStatusCount } from 'utils/payout';

interface IPaymentStatusPillsProps {
  payoutStats?: IPayoutStats;
  isLoading?: boolean;
  activeStatuses?: string[];
  onStatusChange?(selectedStatus: string[]): void;
}

const PILL_APPEARANCE: Record<PayoutStatus, Appearance> = {
  [PayoutStatus.PAID]: Appearance.SUCCESS,
  [PayoutStatus.PAYROLL]: Appearance.SECONDARY,
  [PayoutStatus.CASH]: Appearance.CASH,
  [PayoutStatus.PENDING]: Appearance.WARNING,
  [PayoutStatus.EXPIRED]: Appearance.DANGER,
  [PayoutStatus.CANCELED]: Appearance.NEUTRAL,
};

export const PaymentStatusPills: React.FC<IPaymentStatusPillsProps> = ({ payoutStats, isLoading = false, activeStatuses, onStatusChange }) => (
  <StatusPills
    statuses={PAYOUT_STATUS_DISPLAY_ORDER.map((status) => ({
      label: status,
      value: getPayoutNetTotalByStatus(payoutStats?.byStatus, status),
      count: getPayoutStatusCount(payoutStats?.byStatus, status),
      appearance: PILL_APPEARANCE[status],
    }))}
    isLoading={isLoading}
    activeStatuses={activeStatuses}
    onChange={(s: string[]) => onStatusChange?.(s)}
  />
);
